<!-- TODO - No dialog title? -->
<mat-dialog-content class="items-list">
  @if (!isLoaded) {
    <busy-indicator [big]="true" class="mt10"></busy-indicator>
  }

  @if (isLoaded) {
    @if (!HasResults) {
      <div fxLayout="row" fxLayoutAlign="center center">
        No Results
      </div>
    }
    @if (HasResults) {
      <div>
        @for (item of criteria.SearchResult; track item) {
          <info-card [item]="item" [headerComponent]="headerComponent" [detailComponent]="detailComponent" [expand]="criteria.SearchResult.length == 1" [expandable]="true">
          </info-card>
        }
      </div>
    }
  }

</mat-dialog-content>

<mat-dialog-actions>
  <button mat-raised-button color="primary" mat-dialog-close telemetry="Submission-CardSearchClose">
    Close
  </button>
</mat-dialog-actions>